import React, { Component } from "react";
import { ScrollView, View, StyleSheet, TouchableHighlight } from "react-native";
import Text from "../components_v2/TextFont";
import Loading from "../components/Loading.js";
import { connect } from "react-redux";
import * as Action from "../actions/UserActions";
import Theme from "../argon-ui/Theme";
import { IS_WEB, translate } from "../locales/translate";
import Countdown from "../components/CountDown";
import ArButton from "../argon-ui/Button";
import FontAwesomeIcon from "../components_v2/FontAwesomeIcon";
import GuestExpirePicker from "../components/GuestExpirePicker";
import {
  faPlus,
  faArrowLeft,
  faCheck,
  faUserClock,
  faArrowRight,
} from "../../assets/consts/faCharCodes";
import roles from "../actions/roleHelper";
import PropTypes from "prop-types";
import InputSearch from "../components_v2/InputSearch";
import TabBase from "../nativeBase-ui/TabBase";
import ModalBase from "../nativeBase-ui/ModalBase";
import { HStack } from "native-base";
import MessageBox from "../components_v2/MessageBox";
import { getDir, getIsRTL } from "../util";

class AreaUsersScreen extends Component {
  constructor(props) {
    super(props);
    let { areaId, areaUId, areaName } = this.props.navigation.state.params;
    this.state = {
      areaId: areaId,
      areaUId: areaUId,
      areaName: areaName,
      isLoading: true,
      accessToken: "",
      selectedTab: "allUsers", // "allUsers", "guests"
      selectedUserId: undefined,
      selectedUser: undefined,
      searchQuery: "",
      areaUsers: true,
      showUserAccess: false,
      showGuestAccess: false,
      modifyUserList: [],
      userRole: null,
      searchTerm: "",
      showExpirePicker: false,
      expireValue: 1,
      expireUnit: "hour",
    };
    this.tabs = ["allUsers", "guests"];
  }
  static navigationOptions = ({ screenProps: { translate } }) => ({
    headerTitle: translate("navigation.AreaUsers"),
  });
  async componentDidMount() {
    this.setState(
      {
        accessToken: this.props.appReducer.currentServer.accessToken,
        isLoading: false,
      },
      () => {
        let searchTerm = "";
        this.props.getAll(
          searchTerm,
          this.state.accessToken,
          this.state.areaId,
          this.state.areaUId
        );
      }
    );
  }
  onAddButtonPress = () => {
    let searchTerm = "";
    if (this.props.reducer.isLoading) {
      this.props.getAll(searchTerm, this.state.accessToken, 0, null);
    }
    this.setState({ areaUsers: false });
  };
  onBackButtonPress = () => {
    this.setState({ areaUsers: true });
  };
  getUserIcon(user) {
    var icon = "none";
    {
      /*if user hasn't access in this area  */
    }
    if (!this.state.areaUsers) {
      return icon;
    }
    if (user.accessLevel) {
      icon = user.accessLevel;
    }
    return icon;
  }
  showUserModal = (user) => {
    if (user && user.id) {
      this.setState({
        selectedUser: user,
        selectedUserId: user.id,
        showUserAccess: true,
        userRole: this.state.selectedTab == "allUsers" ? "member" : "guest",
      });
    }
  };
  toggleAccessModal = () => {
    this.setState({
      showUserAccess: false,
      selectedUser: undefined,
      selectedUserId: undefined,
    });
  };
  handleNotify = () => {
    if (this.state.modifyUserList.length == 0) {
      return;
    } else {
      for (var i in this.state.modifyUserList) {
        this.props.NotifyUserModified(
          this.state.modifyUserList[i].userId,
          this.state.accessToken
        );
      }
    }
    // var areaName = this.state.areaId;
    // var areaId = this.state.areaName;
    this.props.navigation.goBack();
  };
  handleOnRoleItemPress = (role) => {
    if (role == "guest") {
      this.setState({ showExpirePicker: true });
      return;
    }
    let {
      modifyUserList,
      selectedUserId: userId,
      selectedUser: user,
      accessToken,
      areaId,
      areaUId,
    } = this.state;
    let IsUserInModifyList = false;
    for (var i in user.areas) {
      const area = user.areas[i];
      if (
        (area.areaId == areaId || (area.areaUId && area.areaUId == areaUId)) &&
        area.accessLevel == role
      ) {
        this.toggleAccessModal();
        return;
      }
    }
    if (modifyUserList.length == 0) {
      this.props.SetMemberAccess(
        userId,
        areaId,
        areaUId,
        role,
        0,
        "",
        accessToken,
        this.props.appReducer.currentBuilding.buildingId
      );
      modifyUserList.push({ userId, role });
    } else {
      for (var i in modifyUserList) {
        const modifyUser = modifyUserList[i];
        if (modifyUser.userId == userId && modifyUser.role != role) {
          modifyUser.role = role;
          IsUserInModifyList = true;
          this.props.SetMemberAccess(
            userId,
            areaId,
            areaUId,
            role,
            0,
            "",
            accessToken,
            this.props.appReducer.currentBuilding.buildingId
          );
          break;
        }
      }
      if (!IsUserInModifyList) modifyUserList.push({ userId, role });
      this.props.SetMemberAccess(
        userId,
        areaId,
        areaUId,
        role,
        0,
        "",
        accessToken,
        this.props.appReducer.currentBuilding.buildingId
      );
    }
    this.setState({ modifyUserList: modifyUserList });
    this.toggleAccessModal();
  };
  handleTabChange = (tab) => {
    this.setState({
      selectedTab: tab,
    });
  };
  render() {
    if (this.state.isLoading || this.props.reducer.areaIsLoading) {
      return <Loading message={translate("splash.fetchingData")} />;
    } else {
      let tmpUsers = [];
      let tmpGuests = [];
      this.props.reducer.users.forEach((element) => {
        element.areas.length !== 0 &&
          element.areas.forEach((areaElement) => {
            if (
              areaElement.areaId === this.state.areaId ||
              areaElement.areaUId === this.state.areaUId
            ) {
              const userModel = {
                fullName: element.fullName,
                description: element.description,
                phoneNumber: element.phoneNumber,
                accessLevel: areaElement.accessLevel,
                expireDate: areaElement.expireDate,
                registerCompleted: element.registerCompleted,
                id: element.id,
              };
              if (areaElement.accessLevel === "guest") {
                tmpGuests.push(userModel);
              } else {
                tmpUsers.push(userModel);
              }
            }
          });
      });
      return (
        <View style={styles.container}>
          <View style={{ paddingHorizontal: 5 }}>
            {/*search text*/}
            <InputSearch
              placeholder={`${translate("app.search")} (${translate(
                "login.fullName"
              )}/${translate("login.phoneNumber")})`}
              value={this.state.searchQuery}
              onChangeText={(txt) => {
                this.setState({ searchQuery: txt });
              }}
            />
            <TabBase
              tab={this.state.selectedTab}
              tabs={this.tabs}
              handleChange={(tab) => this.handleTabChange(tab)}
            />
          </View>
          {/*user tab*/}
          {/*render user */}
          <ScrollView contentContainerStyle={{ paddingHorizontal: 5 }}>
            {this.state.selectedTab === "guests" && tmpGuests.length === 0 ? (
              <MessageBox icon={faUserClock}>
                {translate("app.emptyList")}
              </MessageBox>
            ) : (
              (this.state.selectedTab === "allUsers" ? tmpUsers : tmpGuests)
                .filter((u) => {
                  return (
                    !this.state.searchQuery ||
                    (u.fullName &&
                      u.fullName.indexOf(this.state.searchQuery) >= 0) ||
                    (u.phoneNumber &&
                      (u.phoneNumber.indexOf(this.state.searchQuery) >= 0 ||
                        ("0" + u.phoneNumber).indexOf(this.state.searchQuery) >=
                          0))
                  );
                })
                .map((u) => {
                  return (
                    <UserListItem
                      key={u.id}
                      model={u}
                      areaId={this.state.areaId}
                      icon={this.getUserIcon(u)}
                      onPress={() => this.showUserModal(u)}
                    />
                  );
                })
            )}
          </ScrollView>
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {/*notify user*/}
            {this.state.modifyUserList.length > 0 && (
              <TouchableHighlight
                style={styles.btnRefresh}
                underlayColor={Theme.COLORS.SUCCESS + "55"}
                onPress={this.handleNotify}
              >
                <FontAwesomeIcon icon={faCheck} size={15} color="#FFF" />
              </TouchableHighlight>
            )}
            {/* plus button */}
            {this.state.areaUsers && (
              <TouchableHighlight
                style={styles.btnAdd}
                onPress={this.onAddButtonPress}
              >
                <FontAwesomeIcon icon={faPlus} size={30} color="#FFF" />
              </TouchableHighlight>
            )}
            {/* goback button */}
            {!this.state.areaUsers && (
              <TouchableHighlight
                style={styles.btnAdd}
                onPress={this.onBackButtonPress}
              >
                <FontAwesomeIcon icon={faArrowLeft} size={30} color="#FFF" />
              </TouchableHighlight>
            )}
          </View>
          {this.state.showUserAccess && (
            <ModalBase
              isOpen={this.state.showUserAccess}
              onClose={() => this.toggleAccessModal()}
              // contentStyle={{ height: "100%" }}
            >
              <View style={styles.modalInsideWrapper}>
                <Text style={{ marginVertical: 10 }}>
                  {translate("user.modifyAccessLevel")} {this.state.areaName}
                </Text>
                {this.state.userRole == "support" && (
                  <RoleItem
                    onPress={(role) => this.handleOnRoleItemPress(role)}
                    role="support"
                  />
                )}

                <RoleItem
                  onPress={(role) => this.handleOnRoleItemPress(role)}
                  role="admin"
                />

                <RoleItem
                  onPress={(role) => this.handleOnRoleItemPress(role)}
                  role="member"
                />

                <RoleItem
                  onPress={(role) => this.handleOnRoleItemPress(role)}
                  role="guest"
                />
                <RoleItem
                  onPress={(role) => this.handleOnRoleItemPress(role)}
                  role="none"
                />
                {this.state.showExpirePicker && (
                  <View style={{ width: "100%" }}>
                    <GuestExpirePicker
                      expireUnit={this.state.expireUnit}
                      expireValue={this.state.expireValue}
                      onUnitChange={(unit) => {
                        this.setState({ expireUnit: unit });
                      }}
                      expireValueIsValid={this.state.expireValue > 0}
                      onValueChange={(value) => {
                        var _val = Number(value) || 0;
                        this.setState({
                          expireValue: Math.floor(_val),
                        });
                      }}
                    />
                    <ArButton
                      color="success"
                      style={{
                        marginBottom: 0,
                        width: "100%",
                      }}
                      onPress={() => {
                        let {
                          selectedUserId,
                          areaId,
                          areaUId,
                          accessToken,
                          expireValue,
                          expireUnit,
                        } = this.state;
                        this.props.SetMemberAccess(
                          selectedUserId,
                          areaId,
                          areaUId,
                          "guest",
                          expireValue,
                          expireUnit,
                          accessToken,
                          this.props.appReducer.currentBuilding.buildingId
                        );
                        this.toggleAccessModal();
                      }}
                    >
                      {translate("app.confirm")}
                    </ArButton>
                  </View>
                )}
              </View>
            </ModalBase>
          )}
        </View>
      );
    }
  }
}
class UserListItem extends Component {
  constructor(props) {
    super(props);
    let expireSeconds = this.calculateExpireSeconds();
    this.state = {
      expireSeconds,
    };
  }

  handleOnPress = () => {
    this.props.onPress && this.props.onPress();
  };
  calculateExpireSeconds = () => {
    let expireSeconds = 0;
    if (this.props.model.expireDate) {
      var exp = new Date(this.props.model.expireDate);
      var now = new Date();

      var currentLocalDate = Date.UTC(
        now.getUTCFullYear(),
        now.getUTCMonth(),
        now.getUTCDate(),
        now.getHours(),
        now.getMinutes(),
        now.getSeconds()
      );
      expireSeconds = IS_WEB
        ? (exp.getTime() - now.getTime()) / 1000
        : (exp.getTime() - currentLocalDate) / 1000;
      this.setState({ expireSeconds: expireSeconds });
    }
    return expireSeconds;
  };

  render() {
    return (
      <TouchableHighlight
        underlayColor="#e2e2e2"
        onPress={() => this.handleOnPress()}
        // style={{ borderBottomColor: "#ccc", borderBottomWidth: 1 }}
        style={{
          justifyContent: "center",
          marginBottom: 5,
          height: 65,
          borderRadius: 5,
          backgroundColor: Theme.COLORS.WHITE,

          shadowColor: Theme.COLORS.INPUT,
          shadowOffset: {
            width: 0,
            height: 6,
          },
          shadowOpacity: 0.3,
          shadowRadius: 6.65,
          elevation: 9,
          direction: getDir(),
        }}
      >
        <HStack justifyContent="space-between" alignItems="center" px="2">
          <HStack alignItems="center" space="2" flex={1}>
            <View
              style={[
                styles.iconRoleContainer,
                {
                  backgroundColor:
                    roles.bgColors[this.props.model.accessLevel] ||
                    roles.bgColors.none,
                },
              ]}
            >
              <FontAwesomeIcon
                icon={roles.icons[this.props.icon] || roles.icons.none}
                size={18}
                color={roles.colors[this.props.icon] || roles.colors.none}
                style={{ marginVertical: 5 }}
              />
              {this.props.model.registerCompleted && (
                <Text style={styles.roleText}>
                  {translate(`user.role.${this.props.model.accessLevel}`)}
                </Text>
              )}
              {!this.props.model.registerCompleted && (
                <Text
                  style={[
                    styles.subTitle,
                    { color: Theme.COLORS.WARNING, fontSize: 7, marginTop: 5 },
                  ]}
                >
                  {translate("user.registerNotCompleted")}
                </Text>
              )}
            </View>
            <HStack
              justifyContent="space-between"
              alignItems="center"
              px="2"
              flex={1}
            >
              <View style={{ flex: 1, padding: 10 }}>
                <Text>{this.props.model.fullName}</Text>
                <Text style={styles.subTitle}>
                  {this.props.model.phoneNumber}
                </Text>
                <Text style={styles.subTitle}>
                  {this.props.model.description}
                </Text>
              </View>
              {this.state.expireSeconds > 0 && (
                <Countdown
                  until={this.state.expireSeconds}
                  size={12}
                  digitStyle={{ backgroundColor: "#FFFFFF00", paddingTop: 15 }}
                  timeLabelStyle={{ color: Theme.COLORS.MUTED }}
                  timeLabels={{
                    d: translate("timer.days"),
                    h: translate("timer.hours"),
                    m: translate("timer.minutes"),
                    s: translate("timer.seconds"),
                  }}
                  showSeparator
                />
              )}
            </HStack>
          </HStack>
          <FontAwesomeIcon
            icon={getIsRTL() ? faArrowLeft : faArrowRight}
            size={16}
            style={{ marginHorizontal: 10 }}
            color={Theme.COLORS.MUTED}
          />
        </HStack>
      </TouchableHighlight>
    );
  }
}
class RoleItem extends Component {
  handleOnPress = () => {
    this.props.onPress && this.props.onPress(this.props.role);
  };
  render() {
    var iconName = roles.icons[this.props.role] || roles.icons.none;
    var iconColor = roles.colors[this.props.role] || roles.colors.none;
    return (
      <TouchableHighlight
        style={{
          // flex: 1,
          backgroundColor: "#FFF",
          borderRadius: 10,
          height: 45,
          width: "100%",
          padding: 12,
          justifyContent: "center",
          marginBottom: 5,
        }}
        underlayColor="#f2f2f2"
        onPress={() => {
          this.handleOnPress();
        }}
      >
        <View
          style={{
            flexDirection: getIsRTL() ? "row" : "row-reverse",
            alignItems: "baseline",
          }}
        >
          <Text
            style={{
              flex: 1,
              textAlign: getIsRTL() ? "right" : "left",
              color: iconColor,
            }}
          >
            {translate(`user.role.${this.props.role}`)}
          </Text>
          <FontAwesomeIcon
            icon={iconName}
            color={iconColor}
            size={22}
            style={{ marginHorizontal: 5 }}
          />
        </View>
      </TouchableHighlight>
    );
  }
}

RoleItem.propTypes = {
  role: PropTypes.oneOf(["admin", "support", "member", "guest", "none"]),
};

const styles = StyleSheet.create({
  tittle: {
    fontWeight: "bold",
    fontSize: 22,
  },
  container: {
    flex: 1,
  },
  badge: {
    backgroundColor: Theme.COLORS.WHITE,
    minWidth: 16,
    height: 16,
    borderRadius: 8,
    fontSize: 8,
    color: Theme.COLORS.BLACK,
    textAlign: "center",
    textAlignVertical: "center",
  },
  heading: {
    fontWeight: "bold",
    fontSize: 28,
    padding: 12,
    textAlign: "center",
    borderBottomWidth: 1,
    borderBottomColor: "#ccc",
  },
  btnAdd: {
    width: 60,
    height: 60,
    borderRadius: 30,
    backgroundColor: Theme.COLORS.PRIMARY,
    position: "absolute",
    bottom: 15,
    shadowColor: "#000",
    shadowRadius: 5,
    elevation: 10,
    alignSelf: "center",
    alignItems: "center",
    justifyContent: "center",
  },
  subTitle: {
    color: Theme.COLORS.MUTED,
    fontSize: 11,
    // textAlign: "right",
  },
  modalInsideWrapper: {
    padding: 10,
    alignItems: "center",
    alignSelf: "center",
    width: "100%",
  },
  btnRefresh: {
    width: 30,
    height: 30,
    borderRadius: 15,
    backgroundColor: Theme.COLORS.SUCCESS,
    bottom: 15,
    marginEnd: -100,
    shadowColor: "#000",
    shadowRadius: 5,
    elevation: 10,
    alignSelf: "center",
    alignItems: "center",
    justifyContent: "center",
  },
  userModalButton: {
    width: "90%",
    marginVertical: 15,
    alignSelf: "center",
    flexDirection: "row",
  },
  userModalButtonText: {
    color: Theme.COLORS.WHITE,
    paddingHorizontal: 5,
    flex: 1,
    textAlign: "center",
    fontSize: 16,
  },
  userModalButtonIcon: {
    marginHorizontal: 10,
  },
  iconRoleContainer: {
    justifyContent: "center",
    alignItems: "center",
    width: 55,
    height: 55,
    borderRadius: 5,

    shadowColor: Theme.COLORS.INPUT,
    shadowOffset: {
      width: 0,
      height: 6,
    },
    shadowOpacity: 0.3,
    shadowRadius: 6.65,
    elevation: 9,
  },
  roleText: {
    width: "100%",
    textAlign: "center",
    fontSize: 8,
    color: Theme.COLORS.MUTED,
  },
});

const mapStateToProps = (state) => {
  return {
    reducer: state.UserReducer,
    appReducer: state.AppReducer,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getAll: (search, accessToken, areaId, areaUId) =>
      dispatch(Action.GetAll(search, accessToken, areaId, areaUId)),
    SetMemberAccess: (
      userMemberId,
      areaId,
      areaUId,
      accessLevel,
      expireValue,
      expireUnit,
      accessToken,
      buildingId
    ) =>
      dispatch(
        Action.SetMemberAccess(
          userMemberId,
          areaId,
          areaUId,
          accessLevel,
          expireValue,
          expireUnit,
          accessToken,
          buildingId
        )
      ),
    NotifyUserModified: (userId, accessToken) =>
      dispatch(Action.NotifyUserModified(userId, accessToken)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(AreaUsersScreen);
